export { RESERVABLE_TYPES } from 'shared/util/constants';
export { AMENITIES } from 'shared/util/constants';

// Tracking events labels
export const trackingEventsLabels = {
  breadcrumbs: 'Self Serve - {stepName} - Click - Breadcrumb',
  stepView: 'Self Serve Step Viewed',
  stepCompletion: 'Self Serve - {stepName} - Step Completion',
  orderPreview: 'Self Serve Activity: order preview',
  timeOnStep: 'Time On Self Serve Step',
  loginLink: 'Login link click',
  signUpLink: 'Signup link click',
  chat: {
    clickPhoneNumber: 'Chat phone number clicked from Self Serve Step',
    initiateDrift: 'Drift Chat Session Initiated from Self Serve Step'
  },
  cbp: {
    intermediateSelection: 'CBP Step - Intermediate Selection',
    finalSelection: 'CBP Step - Final Selection'
  }
};

export const RESERVABLE_CONFERENCE_CREDITS = {
  nonHotDesk: 5,
  hotDesk: 2
};

// log in static urls
export const forgotPasswordUrl = 'https://we.id/login/password/forgot';
export const weworkHelpUrl = 'help@wework.com';
export const termsAndConditionsUrl = '/legal/terms';

// sign up form static urls
export const termsOfServiceUrl = '/legal/terms-of-service';
export const privacyPolicyUrl = '/legal/privacy';

// Product types
export const productTypes = Object.freeze({
  OFFICE_SPACE: 'office_space',
  DEDICATED_DESK: 'dedicated_desk',
  OFFICE: 'office'
});

export const paperworkAPIProductTypes = Object.freeze({
  [productTypes.OFFICE_SPACE]: 'OfficeSpace',
  [productTypes.DEDICATED_DESK]: 'DedicatedDesk',
  [productTypes.OFFICE]: 'Office'
});

export const productsTypes = Object.freeze({
  [productTypes.DEDICATED_DESK]: 'Dedicated Desk',
  [productTypes.OFFICE]: 'Office'
});

export const DEFAULT_PLAN = productTypes.OFFICE_SPACE;
export const MEMBERSHIP_LEGAL_ENTITY_NAME = 'WeWork Commons LLC';

export const availabilityTypes = Object.freeze({
  NOW: 'now',
  NEXT_MONTH: 'next_month',
  UNAVAILABLE: 'unavailable'
});

export const MAP_FOR_QUERY_PARAMS = {
  [productTypes.OFFICE_SPACE]: productTypes.OFFICE_SPACE,
  [productTypes.DEDICATED_DESK]: productTypes.DEDICATED_DESK,
  [productTypes.OFFICE]: productTypes.OFFICE
};

export const SELF_SERVE_PLAYBOOK_ID = 211534;
